import React from 'react'
import { Form, Col } from '_zari/core'
import { Select2UsuariosContabilidad } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'
import { KeyEventUtil } from 'utils'
import * as UsuarioService from 'services/usuario.service'

const TrabajadorFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues }) => {
  const onChangeTrabajadorHandler = pickedMember => {
  UsuarioService.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
    setValues({
      ...values,
      idUsuario: pickedMember.value,
      nombreUsuario: `${data.nombres} ${data.apellidos}`.trim()
    })
    KeyEventUtil.leaveOnKeyEvent('select-trabajadores')
  })
}

  const clickClear = React.useCallback(() => {
  setValues({
    ...values,
    idUsuario: '',
    nombreUsuario: ''
  })
  KeyEventUtil.leaveOnKeyEvent('select-trabajadores')
}, [setValues, values])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRABAJADOR' htmlFor='input-trabajadores' md={3} alignRightAt='md' />
        <Col md={9}>
          {iValue ? (
            <ClearInputGroup
              id='input-trabajadores'
              iValue={values.nombreUsuario}
              clickClear={clickClear}
            />
          ) : (
            <Select2UsuariosContabilidad
              disabled={fIsSubmitting}
              id='select-trabajadores'
              onChange={onChangeTrabajadorHandler}
            />
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(TrabajadorFormGroup)
